/**
 * palinka iz
 */
export type FruitSpiritFlavor =
  | 'PLUM'
  | 'PEAR'
  | 'CHERRY'
  | 'SOUR_CHERRY'
  | 'APPLE'
  | 'BLUEBERRY'
  | 'APRICOT'
  | 'QUINCE'
  | 'QUINCE_PEAR'
  | 'GOOSEBERRY'
  | 'ELDERBERRY'
  | 'WOOD_STRAWBERRY'
  | 'BLACKCURRANTS'
  | 'SLOE'
  | 'RASPBERRY'
  | 'PEACH'
  | 'STRAWBERRY'
  | 'BLACKBERRY'
  | 'GRAPE'
  | 'VEGETABLE'
  | 'POMACE_DISTILLATE_OR_POMACE'
  | 'COUPAGE'
  | 'OTHER';

export const FruitSpiritFlavor = {
  Plum: 'PLUM' as FruitSpiritFlavor,
  Pear: 'PEAR' as FruitSpiritFlavor,
  Cherry: 'CHERRY' as FruitSpiritFlavor,
  SourCherry: 'SOUR_CHERRY' as FruitSpiritFlavor,
  Apple: 'APPLE' as FruitSpiritFlavor,
  Blueberry: 'BLUEBERRY' as FruitSpiritFlavor,
  Apricot: 'APRICOT' as FruitSpiritFlavor,
  Quince: 'QUINCE' as FruitSpiritFlavor,
  QuincePear: 'QUINCE_PEAR' as FruitSpiritFlavor,
  Gooseberry: 'GOOSEBERRY' as FruitSpiritFlavor,
  Elderberry: 'ELDERBERRY' as FruitSpiritFlavor,
  WoodStrawberry: 'WOOD_STRAWBERRY' as FruitSpiritFlavor,
  Blackcurrants: 'BLACKCURRANTS' as FruitSpiritFlavor,
  Sloe: 'SLOE' as FruitSpiritFlavor,
  Raspberry: 'RASPBERRY' as FruitSpiritFlavor,
  Peach: 'PEACH' as FruitSpiritFlavor,
  Strawberry: 'STRAWBERRY' as FruitSpiritFlavor,
  Blackberry: 'BLACKBERRY' as FruitSpiritFlavor,
  Grape: 'GRAPE' as FruitSpiritFlavor,
  Vegetable: 'VEGETABLE' as FruitSpiritFlavor,
  PomaceDistillateOrPomace: 'POMACE_DISTILLATE_OR_POMACE' as FruitSpiritFlavor,
  Coupage: 'COUPAGE' as FruitSpiritFlavor,
  Other: 'OTHER' as FruitSpiritFlavor,
};
